var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ filter: true, 'align-end': _vm.alignEnd, wide: _vm.wide }},[_c('span',{staticClass:"label mb-2",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.label) || '&nbsp;')}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }